export const fetchTeamAnalytics = async (teamId = 111) => {
  const year = new Date().getFullYear();
  const [
    scheduleRes,
    vsLeftRes,
    vsRightRes,
    homeAwayRes,
    monthlyRes,
  ] = await Promise.all([
    fetch(`https://statsapi.mlb.com/api/v1/schedule?sportId=1&teamId=${teamId}&season=${year}&gameType=R&hydrate=team,linescore,decisions`),
    fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/stats?stats=statSplits&group=hitting&season=${year}&sitCodes=vl`),
    fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/stats?stats=statSplits&group=hitting&season=${year}&sitCodes=vr`),
    fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/stats?stats=statSplits&group=hitting&season=${year}&sitCodes=h,a`),
    fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/stats?stats=statSplits&group=hitting&season=${year}&sitCodes=m`),
  ]);

  const schedule = scheduleRes.ok ? await scheduleRes.json() : null;
  const vsLeft = vsLeftRes.ok ? await vsLeftRes.json() : null;
  const vsRight = vsRightRes.ok ? await vsRightRes.json() : null;
  const homeAway = homeAwayRes.ok ? await homeAwayRes.json() : null;
  const monthly = monthlyRes.ok ? await monthlyRes.json() : null;

  const allGames = schedule?.dates?.flatMap(d => d.games) || [];

  return { allGames, vsLeft, vsRight, homeAway, monthly };
};